import moment from "moment-timezone";
import { eventStatus } from "./dataProvider/interfaces/IEvent";
import { theme } from "./theme";

// get the event status color
export const getEventStatusColor = (status: eventStatus) => {
  switch (status) {
    case eventStatus.LIVE:
      return theme.palette.primary.main;

    default:
      return theme.palette.grey["800"];
  }
};

export const regex = /\d/; // regex to check for number
export const spChars = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/; // regex to check for special character

export const convertToUTC = (date: string) => new Date(
  moment(new Date(date))
    .tz('UTC')
    .format("YYYY-MM-DDTHH:mm:ss")
)
